module.exports = __webpack_public_path__ + "img/controller.4edd7dec.svg";